import React, { useState, useEffect } from "react";
import { CustomerViewProps } from "./customer-view.props";
import {
  BreadcrumbComponent,
  CustomTabPanelComponent,
} from "../../../common/components";
import CustomerViewDetailsViewPrimaryInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-primary-info/customer-view-details-view-primary-info";
import "./customer-view.scss";
import { getCustomerDetails } from "../../../api/customer";
import CustomerViewDetailsAllTabs from "./customer-view-details-all-tabs";
import { AlertComponent } from "../../../common/components";
import CustomerViewEditViewPrimaryInfo from "./customer-view-details/customer-view-details-edit/customer-view-edit-view-primary-info/customer-view-edit-view-primary-info";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import ViewMeeting from "./customer-view-details/customer-view-details-view/customer-view-details-view-open-activities-info/view-meeting/view-meeting";
import ViewTask from "./customer-view-details/customer-view-details-view/customer-view-details-view-open-activities-info/view-task/view-task";
import CallView from "./customer-view-details/customer-view-details-view/customer-view-details-view-open-activities-info/view-call/view-call";
import { Box, useMediaQuery } from "@mui/material";
import CustomerViewDetailsAllTabsResponsive from "./customer-view-all-tabs-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { breadcrumbLink } from "../customer-list.constant";

const CustomerView: React.FC<CustomerViewProps> = (props: any) => {
  const {
    setLoading = () => {},
    disableCustomerStatus,
    // setViewTaskvalue = () => {},
    // viewTaskvalue = {},
    setCrumbMappingOption = () => {},
    // setViewMeetingvalue = () => {},
    // viewMeetingvalue = {},
    // viewCallValue = {},
    // setViewCallValue = () => {},
  } = props;
  const { canWrite, canDelete, canRead } = useResourcePermissions(
    MODULES.CUSTOMER_PROFILE,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const {
    breadCrumb,
    selectedCustomerId: selectedCustomerIdFromState,
    customerName,
  } = location.state || {};

  const selectedCustomerId =
    props.selectedCustomerId || selectedCustomerIdFromState;

  const [breadcrumbMapping, setBreadcrumbMapping] =
    useState<any>(breadcrumbLink);
  // Task
  const [internalViewTask, setInternalViewTask] = useState<{
    open: boolean;
    taskId: number | null;
  }>({
    open: false,
    taskId: null,
  });
  const viewTaskvalue = props.viewTaskvalue || internalViewTask;
  const setViewTaskvalue = props.setViewTaskvalue || setInternalViewTask;

  // Meeting
  const [internalViewMeeting, setInternalViewMeeting] = useState<{
    open: boolean;
    meetingId: number | null;
  }>({
    open: false,
    meetingId: null,
  });
  const viewMeetingvalue = props.viewMeetingvalue || internalViewMeeting;
  const setViewMeetingvalue =
    props.setViewMeetingvalue || setInternalViewMeeting;

  // Call
  const [internalViewCall, setInternalViewCall] = useState<{
    open: boolean;
    callId: number | null;
  }>({
    open: false,
    callId: null,
  });
  const viewCallValue = props.viewCallValue || internalViewCall;
  const setViewCallValue = props.setViewCallValue || setInternalViewCall;

  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [customerDetails, setCustomerDetails] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [viewPrimaryInfoOpen, setViewPrimaryInfoOpen] =
    useState<boolean>(false);
  const [uploadedImage, setUploadedImage] = useState("");
  const [uploadedImageFile, setUploadedImageFile] = useState<File | null>(null);
  const [viewFullInfoOpen, setViewFullInfoOpen] = useState<boolean>(false);
  const [viewAddFullInfoOpen, setViewAddFullInfoOpen] =
    useState<boolean>(false);
  const [removeImage, setRemoveImage] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");

  const resetImageUpload = () => {
    setUploadedImage(customerDetails?.lead_profile_file_Url || "");
    setUploadedImageFile(null);
    setRemoveImage(false);
  };
  const fetchCustomerDetails = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetails(selectedCustomerId);
      setCustomerDetails(response.data.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead.",
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, [selectedCustomerId]);

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  useEffect(() => {
    if (breadCrumb) {
      const customMapping = [
        {
          label: "Customer Management",
          link: routes.CUSTOMERLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setViewTaskvalue({ open: false, taskId: null });
            setViewMeetingvalue({ open: false, meetingId: null });
            setViewCallValue({ open: false, callId: null });
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.CUSTOMERLIST);
          },
        },
        {
          label: "Customer Profile",
          link: routes.CUSTOMERLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setViewTaskvalue({ open: false, taskId: null });
            setViewMeetingvalue({ open: false, meetingId: null });
            setViewCallValue({ open: false, callId: null });
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.CUSTOMERLIST);
          },
        },
        { label: customerName, link: "" },
      ];
      setBreadcrumbMapping(customMapping);
      setCrumbMappingOption();
    }
  }, [breadCrumb, customerName]);

  return (
    <>
      {breadCrumb && (
        <Box className="breadcrumb-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={breadcrumbMapping}
            showBackArrow
            handleBackArrowClick={() => navigate(routes.CUSTOMERLIST)}
          />
        </Box>
      )}
      <div className="customer-list-view">
        <div
          style={{
            display:
              !viewTaskvalue.open &&
              !viewMeetingvalue.open &&
              !viewCallValue?.open
                ? "block"
                : "none",
          }}
        >
          {isMobile ? (
            <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
              <CustomerViewDetailsViewPrimaryInfo
                customerDetails={customerDetails}
                viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                viewFullInfoOpen={viewFullInfoOpen}
                uploadedImage={uploadedImage}
                setUploadedImage={setUploadedImage}
                setUploadedImageFile={setUploadedImageFile}
                setRemoveImage={setRemoveImage}
              />
            </div>
          ) : (
            <CustomTabPanelComponent value={0} index={0}>
              {viewPrimaryInfoOpen ? (
                <CustomerViewEditViewPrimaryInfo
                  setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                  viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                />
              ) : (
                <CustomerViewDetailsViewPrimaryInfo
                  customerDetails={customerDetails}
                  viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                  setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                  viewFullInfoOpen={viewFullInfoOpen}
                  uploadedImage={uploadedImage}
                  setUploadedImage={setUploadedImage}
                  setUploadedImageFile={setUploadedImageFile}
                  setRemoveImage={setRemoveImage}
                  setAlertMessage={setAlertMessage}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                />
              )}
            </CustomTabPanelComponent>
          )}
          {isMobile ? (
            <CustomerViewDetailsAllTabsResponsive
              customerDetails={customerDetails}
              selectedCustomerId={selectedCustomerId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchCustomerDetails={fetchCustomerDetails}
              onCustomerNameUpdate={props.onCustomerNameUpdate}
              leadId={selectedCustomerId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              disableCustomerStatus={disableCustomerStatus}
              permissions={{ canWrite, canDelete, canRead }}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              setViewTaskvalue={setViewTaskvalue}
              setViewMeetingvalue={setViewMeetingvalue}
              setViewCallValue={setViewCallValue}
              isMobile={isMobile}
            />
          ) : (
            <CustomerViewDetailsAllTabs
              customerDetails={customerDetails}
              selectedCustomerId={selectedCustomerId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchCustomerDetails={fetchCustomerDetails}
              onCustomerNameUpdate={props.onCustomerNameUpdate}
              leadId={selectedCustomerId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              disableCustomerStatus={disableCustomerStatus}
              permissions={{ canWrite, canDelete, canRead }}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              setViewTaskvalue={setViewTaskvalue}
              setViewMeetingvalue={setViewMeetingvalue}
              setViewCallValue={setViewCallValue}
            />
          )}
          <AlertComponent
            message={alertMessage}
            type={alertType}
            open={alertOpen}
            onClose={handleAlertClose}
          />
        </div>
        {!viewTaskvalue.open ? (
          ""
        ) : (
          <ViewTask
            taskId={viewTaskvalue?.taskId}
            customerDetails={customerDetails}
          />
        )}
        {!viewMeetingvalue.open ? (
          ""
        ) : (
          <ViewMeeting
            meetingId={viewMeetingvalue?.meetingId}
            customerDetails={customerDetails}
          />
        )}
        {!viewCallValue.open ? (
          ""
        ) : (
          <CallView
            callId={viewCallValue.callId}
            customerDetails={customerDetails}
          />
        )}
      </div>
    </>
  );
};

export default CustomerView;
